import * as React from 'react';
const SvgBubbleLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M21.67 5.64c-.29-.56-.75-1.02-1.31-1.31C19.72 4 18.88 4 17.2 4H6.8c-1.68 0-2.52 0-3.16.33-.56.29-1.02.75-1.31 1.31C2 6.282 2 7.123 2 8.804v6.403c0 1.681 0 2.521.33 3.162.29.56.75 1.02 1.31 1.31.53.27 1.2.32 2.36.32v1.752c0 1.09 1.29 1.65 2.09.92L11.03 20h6.17c1.68 0 2.52 0 3.16-.33.56-.29 1.02-.75 1.31-1.311.33-.64.33-1.481.33-3.162V8.793c0-1.681 0-2.522-.33-3.162zM20 15.207c0 1 0 2.041-.11 2.251-.1.19-.25.34-.44.44-.21.11-1.25.11-2.25.11h-6.71c-.27 0-.52.11-.71.29L7.5 20.58v-2.071c0-.28-.22-.5-.5-.5H6c-.7 0-1.3-.03-1.45-.11-.19-.1-.34-.25-.44-.44C4 17.247 4 16.206 4 15.205V8.803c0-1 0-2.041.11-2.252.1-.19.25-.34.44-.44.21-.11 1.25-.11 2.25-.11h10.4c1 0 2.04 0 2.25.11.19.1.34.25.44.44.11.21.11 1.251.11 2.252z"
    />
  </svg>
);
export default SvgBubbleLeft;
